import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PaymentTerm } from '@cemex-core/cmx-api';
import { select, Store } from '@ngrx/store';
import { PAYMENT_TERM } from '@ordersnproducts/utils/payments-terms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { getOneClickPaymentsAt } from '../../selectors/one-click-payments.selector';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/field-select-config.interface';

@Injectable()
export class OneClickPaymentsExtendedLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup, config?: FieldSelectConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOneClickPaymentsAt(config['at'])),
      map((payments) => {
        if (payments.length === 1) {
          formGroup.controls[OneClickBuilderField.Payment].setValue(payments[config['at']].paymentTermId);
        }
        return payments
          .filter((payment) => !this.isCash(payment))
          .map((payment) => {
            return {
              id: payment.paymentTermId,
              name: `${payment.paymentTermDesc}`,
            };
          });
      }),
    );
  }

  private isCash(paymentTerm: PaymentTerm): boolean {
    return paymentTerm.paymentTermCode === PAYMENT_TERM.CASH;
  }
}
